import { path } from '@cbridge-utils/redux';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleIntervalAction } from '../scheduleInterval.action';
import { scheduleIntervalStoreSelector } from '../scheduleInterval.selector';
import { makeIntervalId } from '../_helpers/scheduleIntervalId';
import { ScheduleIntervalTranslator } from '../scheduleInterval.translator';

type IState =
  & IGetSelectorStateType<typeof scheduleIntervalStoreSelector>;

type IDependencies = IClientApiDependencySegment;

export const removeIntervalEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([params, state]) => {
    const { scheduleId, index } = params;

    const data = path(scheduleIntervalStoreSelector).data()(state);
    const intervals = data[scheduleId]?.slice();

    if (intervals) {
      intervals.splice(index, 1);

      const updatedIntervals = intervals.map((interval, newIndex) => ({
        ...interval,
        intervalId: makeIntervalId(scheduleId, newIndex),
      }));

      const apiIntervals = updatedIntervals.map(ScheduleIntervalTranslator.toApi);

      return dependencies.api.updateScheduleIntervalList({ scheduleId, intervals: apiIntervals }).pipe(
        mergeMap(() => {
          return [
            ScheduleIntervalAction.remove.done({ params, result: updatedIntervals }),
          ];
        }),
        catchApiError((error) => {
          return [
            ScheduleIntervalAction.remove.failed({ params, error }),
            createApiErrorNotification(error),
          ];
        }),
      );
    }

    return [
      ScheduleIntervalAction.remove.done({ params }),
    ];
  }),
);
